import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { RequestOptions } from "@angular/http";
import { BaseResponse } from "../objects/common/baseResponse";
import { EmailResponse } from "../objects/email/emailResponse";
import { EmailRequest } from "../objects/email/EmailRequest";
import { PaymentEmailRequest } from "../objects/email/PaymentEmailRequest";
/**
 * Created by vadim.m on 9/19/2017.
 */

@Injectable()
export class EmailService extends BaseApi {

    public sendOrderToCustomer(emailRequest: EmailRequest): Promise<BaseResponse<EmailResponse>> {
        return this.post(new RequestOptions({
            url: `email/order/${emailRequest.OrderId}`,
            body: emailRequest
        }))
    }

    public sendPaymentEmail(emailRequest: PaymentEmailRequest): Promise<BaseResponse<EmailResponse>> {
        return this.post(new RequestOptions({
            url: `email/orderpaymentemail`,
            body: emailRequest
        }))
    }

    public sendQuestionEmailToAgent(email: string, body:string): Promise<BaseResponse<EmailResponse>> {
        return this.post(new RequestOptions({
            url: `email/question?email=${email}`,
            body: {Body: body}
        }))
    }

    public sendNotificationToSalesEmail(email:string): Promise<BaseResponse<EmailResponse>>{
        return this.post(new RequestOptions({
            url: `email/notification?email=${email}`,
        }))
    }

    public sendProductsToBB(sellerId: string, storeId: string): Promise<BaseResponse<EmailResponse>>{
        return this.get(new RequestOptions({
            url: `amazon/seller/${sellerId}/store/${storeId}/email`,
        }))
    }

    public sendPayPalPaymentRequest(customerId: number): Promise<BaseResponse<EmailResponse>> {
        return this.post(new RequestOptions({
            url: `email/paypalpaymentrequest/${customerId}`
        }));
    }

    public sendSubscribeToPARSStatus(ccn: string, email: string, orderId: string = null): Promise<BaseResponse<EmailResponse>> {
        return this.get(new RequestOptions({
            url: `email/subscribeToPARSStatus/${ccn}/${email}/${orderId}`
        }));
    }

    public sendGetStartedEmail(customerEmail: string): Promise<BaseResponse<EmailResponse>>{
        return this.get(new RequestOptions({
            url: `email/first-login/${customerEmail}`,
        }))
    }

    public unsubscribeEmail(ccn: string, email: string): Promise<BaseResponse<EmailResponse>> {
        return this.get(new RequestOptions({
            url: `email/unsubscribe/${ccn}/${email}`,
        }));
    }

    public inviteCustomerToSelfServeApp(email: string): Promise<BaseResponse<EmailResponse>> {
        return this.get(new RequestOptions({
            url: `email/invite-customer/${email}`,
        }));
    }
}



// WEBPACK FOOTER //
// ./app/services/emailService.ts